import Vuex, { StoreOptions } from "vuex";
import { RootState } from "@/types/common";
import { common } from "./common";
import { home } from "./home";
import { search } from "./search";
import { favorites } from "./favorites";
import { recipes } from "./recipes";
import { shoppingList } from "./shoppingList";
import { fridgeDetails } from "./fridgeDetails";
import { pantry } from "./pantry";
import { mypage } from "./mypage";

const store: StoreOptions<RootState> = {
  state: {
    version: "1.0.0"
  },
  modules: {
    common,
    home,
    search,
    favorites,
    recipes,
    shoppingList,
    fridgeDetails,
    pantry,
    mypage
  }
};

export default new Vuex.Store<RootState>(store);
